import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';
import { JtnUiBtn } from '../jtn-ui-btn';
import { JtnUiTypography } from '../jtn-ui-typography';

import styles from './jtn-ui-promo-block.style.scss?module';

interface Events {
  onBtnClicked: MouseEvent;
}

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiPromoBlock',
    props: {
      btnText: {
        type: String,
        default: ''
      },
      btnUrl: {
        type: String,
        default: ''
      },
      targetUrl: {
        type: String,
        default: '_blank'
      }
    },
    render() {
      return (
        <div class={[styles.promoBlock, this.btnText !== '' ? styles.withoutBtn : '']}>
          <div class={styles.content}>
            <div class={styles.iconWrap}>{this.$slots.icon}</div>
            <JtnUiTypography
              class={styles.text}
              tag="div"
              type="font-second-news-txt"
              linkType="link-blue"
            >
              {this.$slots.default}
            </JtnUiTypography>
          </div>
          {this.btnText && (
            <JtnUiBtn
              class={styles.btn}
              href={this.btnUrl}
              target={this.targetUrl}
              onClick={(e: MouseEvent) => this.$emit('btnClicked', e)}
            >
              {this.btnText}
            </JtnUiBtn>
          )}
        </div>
      );
    }
  });
